import { ApplicationConfig, mergeApplicationConfig } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { commonConfig } from './app.config.common';
import { environment } from './environments/environment';
import {
    complex_links,
    request_hotel_motor,
    organization_name,
    SCROLL_OFFSET_TOKEN,
} from 'ctt-babylon';

export const appConfig: ApplicationConfig = mergeApplicationConfig(
    commonConfig,
    {
        providers: [
            provideClientHydration(),
            provideAnimations(),
            {
                provide: complex_links,
                useValue: environment.menuComplexLinks,
            },
            {
                provide: organization_name,
                useValue: environment.organizationName,
            },
            {
                provide: SCROLL_OFFSET_TOKEN,
                useValue: -160, // Ajusta este valor según la altura de tu header
            },
        ],
    }
);
